import type { Snapshot } from '../../generated/api/types.gen.js';

export function snapshotOutputObject(snapshot: Snapshot): Record<string, unknown> | null {
  const data = (snapshot.outputJson ?? snapshot.output) as unknown;
  return data && typeof data === 'object' && !Array.isArray(data) ? (data as Record<string, unknown>) : null;
}

export function inferJsonSchema(value: Record<string, unknown>): Record<string, unknown> {
  const properties: Record<string, unknown> = {};
  const required: string[] = [];
  for (const [key, child] of Object.entries(value)) {
    properties[key] = inferSchemaValue(child);
    if (child !== undefined && child !== null) required.push(key);
  }
  return {
    type: 'object',
    properties,
    required,
    additionalProperties: true,
  };
}

function inferSchemaValue(value: unknown): Record<string, unknown> {
  if (Array.isArray(value)) {
    const first = value.find((item) => item !== null && item !== undefined);
    return { type: 'array', items: first === undefined ? {} : inferSchemaValue(first) };
  }
  if (value && typeof value === 'object') {
    return inferJsonSchema(value as Record<string, unknown>);
  }
  if (typeof value === 'number') return { type: 'number' };
  if (typeof value === 'boolean') return { type: 'boolean' };
  if (value === null) return { type: ['string', 'number', 'boolean', 'object', 'array', 'null'] };
  return { type: 'string' };
}

export function schemaFieldNames(schema: Record<string, unknown> | null): string[] {
  const properties = schema?.properties;
  if (!properties || typeof properties !== 'object' || Array.isArray(properties)) return [];
  return Object.keys(properties as Record<string, unknown>).sort();
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}
